import mainImg from "../../../assets/corner-crausel-abs-270-degree.webp";
import thumb1 from "../../../assets/corner-crausel-abs-270-degree-thumb-one.webp";
import thumb2 from "../../../assets/corner-crausel-abs-270-degree-thumb-two.webp";


import mainImg1 from "../../../assets/white swing corner 900mm.webp";
import thumb3 from "../../../assets/white swing corner 900mm-thumb-one.webp";
import thumb4 from "../../../assets/white swing corner 900mm-thumb-two.webp";

import mainImg2 from "../../../assets/wooden-corner-clousel.webp";
import thumb5 from "../../../assets/wooden-corner-clousel.webp";
import thumb6 from "../../../assets/wooden-corner-clousel.webp";



import mainImg3 from "../../../assets/grey swing corner 900mm.webp";
import thumb7 from "../../../assets/grey swing corner 900mm-thumb-one.webp";
import thumb8 from "../../../assets/grey swing corner 900mm-thumb-two.webp";




import mainImg5 from "../../../assets/full pullout  swing corner .webp";
import thumb11 from "../../../assets/full pullout  swing corner-thumb-one.webp";
import thumb12 from "../../../assets/full-pullout-thumb-two.webp";

import mainImg6 from "../../../assets/aluminium  swing corner.webp";
import thumb13 from "../../../assets/aluminium- swing- corner-thumb-one.webp";
import thumb14 from "../../../assets/aluminium-swing-corner-thumb-two.webp";


import mainImg7 from "../../../assets/universal-magic-corner.jpeg";
import thumb15 from "../../../assets/universal-magic-corner.jpeg";
import thumb16 from "../../../assets/universal-magic-corner.jpeg";


import mainImg8 from "../../../assets/universal-magic-corner-wooden.jpeg";
import thumb17 from "../../../assets/universal-magic-corner-wooden.jpeg";
import thumb18 from "../../../assets/universal-magic-corner-wooden.jpeg";

import mainImg9 from "../../../assets/universal-magic-corner-chrome.jpeg";
import thumb19 from "../../../assets/universal-magic-corner-chrome.jpeg";
import thumb20 from "../../../assets/universal-magic-corner-chrome.jpeg";

export const cornerSolutions = [
 {
  code: "CS-01",
  name: "Corner Carousel ABS 270 Degree",
  category: "corner-solutions",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  // ✅ PRICE SECTION
  price: "₹8100",
  oldPrice: "₹10,500",
  sku: "CS-01",
  stock: "In Stock",

  // ✅ BUTTON LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Corner Carousel Inquiry",

  // ✅ VIDEO (already correct format)
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION
  short:
    "Corner Carousel ABS 270 Degree is a smart storage solution designed for modular kitchen corner cabinets. Its 270-degree rotating mechanism allows easy access to stored items while maximizing unused corner space.",

  // ✅ FEATURES
  features: [
    "270-degree rotating design for easy access",
    "High-quality ABS material construction",
    "Moisture-resistant and durable",
    "Ideal for modular kitchen corner cabinets",
    "Smooth and silent rotation mechanism",
    "Space-saving corner solution"
  ],

  // ✅ NORMAL SPECIFICATIONS
  specifications: [
    { label: "Material", value: "ABS Plastic" },
    { label: "Rotation", value: "270 Degree" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE (IMPORTANT)
  specTable: [
    {
      item: "Corner Carousel",
      code: "7734",
      size: "600mm",
      finish: "White ABS"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Corner Carousel ABS 270 Degree?",
      answer:
        "It is a rotating kitchen storage unit designed for corner cabinets, allowing easy access to stored items with a 270-degree movement."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in modular kitchen corner cabinets to efficiently utilize unused corner space."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality ABS material which is strong, lightweight, and long-lasting."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is designed for easy installation in standard kitchen cabinets."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store kitchen items like utensils, containers, groceries, and daily essentials."
    }
  ]
},
{
  code: "CS-02",
  name: " White Swing Corner 900mm ",
  category: "corner-solutions",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹8550",
  oldPrice: "₹10,999",
  sku: "7101",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Soft Close Swing Corner Inquiry",

  // ✅ VIDEO (add if available, warna blank bhi chhod sakta है)
  video: "https://www.youtube.com/embed/H0Cj2_PKiP8",

  // ✅ SHORT DESC
  short:
    "White Swing Corner 900mm is a smart storage solution made for large corner cabinets in modular kitchens. Its smooth swing-out mechanism provides easy access to stored items while making the best use of corner space. The clean white finish matches modern kitchen interiors and keeps storage neat and organized.",

  // ✅ FEATURES
  features: [
     "Efficient utilization of corner space",
     "Rust-resistant and long-lasting use",
      "Easy installation and low maintenance",
      "Ideal for organizing kitchen essentials",
      "Elegant white finish for a clean look",
    ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Chrome Finish" },
    { label: "Mechanism", value: "Soft Close Swing" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Swing Corner",
      code: "7101",
      size: "",
      finish: "White"
    },
    {
      item: "Swing Corner",
      code: "7102",
      size: "",
      finish: "White"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Soft Close Swing Corner?",
      answer:
        "It is a modular kitchen corner storage system with a swing-out mechanism and soft-close function for smooth and silent operation."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in modular kitchen corner cabinets to efficiently utilize corner space."
    },
    {
      question: "What are its advantages?",
      answer:
        "It provides easy access to stored items, smooth movement, better organization, and noise-free closing."
    },
    {
      question: "Is it suitable for heavy items?",
      answer:
        "Yes, it is designed to hold kitchen utensils, containers, and groceries securely."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is designed for standard cabinet installation and is easy to set up."
    }
  ]
},


{
  code: "CS-08",
  name: "Wooden Corner Carousel",
  category: "corner-solutions",

  mainImage: mainImg2,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹9180",
  oldPrice: "₹10,500",
  sku: "7794",
  stock: "In Stock",

  // ✅ LINKS
   catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Wooden Corner Carousel Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION (FIXED)
  short:
    "Wooden Corner Carousel is a premium modular kitchen storage solution designed for corner cabinets. It features a smooth rotating mechanism that allows easy access to stored items while maximizing corner space. The wooden finish gives a stylish and elegant look to modern kitchens.",

  // ✅ FEATURES (CORRECTED FOR CAROUSEL)
  features: [
    "Smooth rotating carousel mechanism",
    "Efficient use of corner cabinet space",
    "Premium wooden finish for elegant look",
    "Easy access to all stored items",
    "Durable and long-lasting construction",
    "Ideal for modern modular kitchens"
  ],

  // ✅ SPECIFICATIONS (UPDATED)
  specifications: [
    { label: "Material", value: "Wood + Metal Frame" },
    { label: "Mechanism", value: "Rotating Carousel" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Wooden Corner Carousel",
      code: "7794",
      size: "600mm",
      finish: "Wood Finish"
    },
    {
      item: "Wooden Corner Carousel",
      code: "7795",
      size: "900mm",
      finish: "Wood Finish"
    }
  ],

  // ✅ FAQ (UPDATED)
  faq: [
    {
      question: "What is a Wooden Corner Carousel?",
      answer:
        "It is a rotating kitchen storage unit designed for corner cabinets that allows easy access to items through a carousel mechanism."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in modular kitchen corner cabinets to utilize corner space efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It provides 360-degree access, better organization, and maximizes corner storage space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store utensils, containers, groceries, and kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with strong materials ensuring long-lasting performance."
    }
  ]
},
{
  code: "CS-04",
  name: "Grey Swing Corner 900mm",
  category: "corner-solutions",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE
  price: "₹8125",
  oldPrice: "₹17,000",
  sku: "7103",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/grey-swing-corner.pdf",
  inquiry: "https://wa.me/919650100908?text=Grey Swing Corner 900mm Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESC (clean)
  short:
    "Grey Swing Corner 900mm is a premium storage solution designed for large corner cabinets in modular kitchens. It features a smooth swing-out mechanism that provides easy access to stored items while maximizing corner space. The elegant grey finish enhances modern kitchen aesthetics.",

  // ✅ FEATURES
  features: [
    "Smooth swing-out mechanism for easy access",
    "Designed for 900mm corner cabinets",
    "Maximizes corner space utilization",
    "Modern grey finish for premium look",
    "High load-bearing capacity",
    "Durable and long-lasting construction"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Powder Coated Grey Finish" },
    { label: "Size", value: "900mm" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Grey Swing Corner",
      code: "7103",
      size: "900mm",
      finish: "Grey"
    },
    {
      item: "Grey Swing Corner",
      code: "7104",
      size: "",
      finish: "Grey"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Grey Swing Corner 900mm?",
      answer:
        "It is a modular kitchen corner storage unit designed for 900mm cabinets with a smooth swing-out mechanism for easy access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in modular kitchen corner cabinets to utilize unused corner space efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It provides better accessibility, organized storage, and maximizes corner cabinet space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store pots, pans, containers, groceries, and daily kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials ensuring long-lasting performance."
    }
  ]
},


  
{
  code: "CS-06",
  name: "Full Pull Out Swing Corner",
  category: "corner-solutions",

  mainImage: mainImg5,
  thumbnails: [thumb11, thumb12],

  // ✅ PRICE
  price: "₹9180",
  oldPrice: "₹19,500",
  sku: "7735",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Full Pull Out Swing Corner Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/bixS6S3-Rw8",

  // ✅ SHORT DESC
  short:
    "Full Pull Out Swing Corner is a premium modular kitchen storage solution designed for corner cabinets. It allows the entire unit to pull out and swing smoothly, providing full visibility and easy access to stored items while maximizing corner space.",

  // ✅ FEATURES
  features: [
    "Full pull-out and swing mechanism for complete access",
    "Maximizes unused corner cabinet space",
    "High load-bearing capacity for heavy items",
    "Smooth and silent operation",
    "Durable and rust-resistant construction",
    "Ideal for organizing kitchen essentials"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Chrome Finish" },
    { label: "Mechanism", value: "Full Pull Out Swing" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Full Pull Out Swing Corner",
      code: "7735",
      size: "",
      finish: ""
    },
    {
      item: "Full Pull Out Swing Corner",
      code: "7736",
      size: "",
      finish: ""
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Full Pull Out Swing Corner?",
      answer:
        "It is a modular kitchen corner storage system that allows shelves to fully pull out and swing, providing complete access to stored items."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in modular kitchen corner cabinets to efficiently utilize unused corner space."
    },
    {
      question: "What are the advantages?",
      answer:
        "It offers full visibility, easy access, better organization, and maximizes corner cabinet storage."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store pots, pans, containers, groceries, and other kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials with a strong and long-lasting structure."
    }
  ]
},

{
  code: "CS-07",
  name: "Aluminium Swing Corner",
  category: "corner-solutions",

  mainImage: mainImg6,
  thumbnails: [thumb13, thumb14],

  // ✅ PRICE
  price: "₹12052",
  oldPrice: "₹18,500",
  sku: "7737",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/aluminium-swing-corner.pdf",
  inquiry: "https://wa.me/919650100908?text=Aluminium Swing Corner Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESC (clean)
  short:
    "Aluminium Swing Corner is a durable and lightweight modular kitchen storage solution designed for corner cabinets. Made from high-quality aluminium, it offers rust resistance and smooth swing-out functionality for easy access while maximizing corner space.",

  // ✅ FEATURES (fixed)
  features: [
    "High-quality aluminium construction",
    "Lightweight and rust-resistant design",
    "Smooth swing-out mechanism for easy access",
    "Ideal for modular kitchen corner cabinets",
    "Keeps items organized and easily visible",
    "Efficient utilization of corner space"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium" },
    { label: "Mechanism", value: "Swing Out" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Aluminium Swing Corner",
      code: "7737",
      size: "",
      finish: "Aluminium"
    },
    {
      item: "Aluminium Swing Corner",
      code: "7738",
      size: "",
      finish: "Aluminium"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is an Aluminium Swing Corner?",
      answer:
        "It is a modular kitchen corner storage unit made from aluminium that swings out for easy access to stored items."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in modular kitchen corner cabinets to efficiently utilize unused corner space."
    },
    {
      question: "What are the advantages?",
      answer:
        "It is lightweight, rust-resistant, durable, and provides smooth operation with better accessibility."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store pots, pans, containers, groceries, and daily kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, aluminium construction ensures long-lasting performance and resistance to corrosion."
    }
  ]
},
{
  code: "CS-08",
  name: "Universal Magic Corner Glass (With Bidding) Grey",
  category: "corner-solutions",

  mainImage: mainImg7,
  thumbnails: [thumb15, thumb16],

  // ✅ PRICE
  price: "₹16284",
  oldPrice: "₹25,000",
  sku: "7187",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/magic-corner-glass.pdf",
  inquiry: "https://wa.me/919650100908?text=Universal Magic Corner Glass Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION (clean)
  short:
    "Universal Magic Corner Glass is an advanced modular kitchen storage solution designed to maximize corner cabinet space. It features a smart pull-out mechanism that brings hidden baskets forward, ensuring easy access to all stored items. The glass finish adds a premium and modern look to your kitchen.",

  // ✅ FEATURES (optimized)
  features: [
    "Smart pull-out mechanism for full accessibility",
    "Maximizes hard-to-reach corner cabinet space",
    "Premium glass basket design",
    "Smooth and silent sliding system",
    "Multiple baskets for organized storage",
    "Strong and durable construction"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Glass" },
    { label: "Mechanism", value: "Magic Corner Pull-Out" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Magic Corner Glass",
      code: "7187",
      size: "900mm",
      finish: "Glass + Grey"
    },
    // {
    //   item: "Magic Corner Glass",
    //   code: "MCG-900",
    //   size: "900mm",
    //   finish: "Glass + Chrome"
    // }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Universal Magic Corner?",
      answer:
        "It is a modular kitchen corner storage system that uses a pull-out mechanism to make corner spaces easily accessible."
    },
    {
      question: "How does it work?",
      answer:
        "When the cabinet door opens, the baskets slide out and bring inner baskets forward for full access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in modular kitchen corner cabinets to maximize unused space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store utensils, containers, groceries, and daily kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is built with strong materials and smooth sliding technology for long-lasting performance."
    }
  ]
},

{
  code: "CS-09",
  name: "Magic Corner Grey",
  category: "corner-solutions",

  mainImage: mainImg8,
  thumbnails: [thumb17, thumb18],

  // ✅ PRICE
  price: "₹22,800",
  oldPrice: "₹26,500",
  sku: "CS-09",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Universal Magic Corner Wooden Grey Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION (clean)
  short:
    "Magic Corner Grey is a premium modular kitchen storage solution designed to maximize corner cabinet space. It features a smart pull-out mechanism with elegant wooden grey baskets that slide out smoothly, providing easy access to all stored items while enhancing kitchen aesthetics.",

  // ✅ FEATURES (optimized)
  features: [
    "Smart pull-out mechanism for easy access",
    "Premium wooden grey baskets for modern look",
    "Maximizes hard-to-reach corner cabinet space",
    "Smooth and silent sliding system",
    "Multiple baskets for organized storage",
    "Strong and durable construction"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Grey Finish" },
    { label: "Mechanism", value: "Magic Corner Pull-Out" },
    { label: "Usage", value: "Kitchen Corner Storage" },
    { label: "Installation", value: "Cabinet Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Magic Corner  Grey",
      code: "7107",
      size: "",
      finish: "Wooden Grey"
    },
    // {
    //   item: "Magic Corner Grey",
    //   code: "MCWG-900",
    //   size: "",
    //   finish: "Wooden Grey"
    // }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Magic Corner Grey?",
      answer:
        "It is a modular kitchen corner storage system with  grey baskets and a pull-out mechanism for easy access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in modular kitchen corner cabinets to efficiently utilize unused space."
    },
    {
      question: "How does it work?",
      answer:
        "When the cabinet door opens, outer baskets slide out and inner baskets move forward for full accessibility."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store utensils, containers, groceries, and kitchen essentials."
    },
    {
      question: "What is the advantage of grey finish?",
      answer:
        "The  grey finish gives a premium look while maintaining strong and organized storage."
    }
  ]
},


 {
  code: "CS-010",
  name: "WOODEN MAGIC CORNER CHROME",
  category: "corner-solutions",

  mainImage: mainImg9,
  thumbnails: [thumb19, thumb20],

  short:
    "The Wooden Magic Corner Chrome is an advanced kitchen storage solution designed to efficiently utilize hard-to-reach corner cabinet spaces. Featuring a strong chrome frame with elegant wooden shelves, it offers durability along with a premium modern look. Its smooth pull-out mechanism ensures easy access to stored items, maximizing storage space and improving kitchen organization.",

  features: [
    "Smart corner storage solution for maximum space utilization",
    "Strong chrome-plated metal frame for durability",
    "Premium wooden shelves for elegant finish",
    "Smooth pull-out sliding mechanism",
    "Easy access to hard-to-reach corner spaces",
    "Rust-resistant and long-lasting structure",
    "Ideal for modular kitchens and cabinets"
  ],

  /* ✅ PRICE */
  price: "₹16284",
  oldPrice: "₹19999",

  /* ✅ SKU + STOCK */
  sku: "7107",
  stock: "In Stock",

  /* ✅ VIDEO */
   catalogue: "/Slimline Price List-2026.pdf",

  inquiry: "https://wa.me/919650100908?text=Mark ",

  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Chrome + Wood" },
    { label: "Type", value: "Magic Corner Storage System" },
    { label: "Mechanism", value: "Pull-out Sliding System" },
    { label: "Application", value: "Corner Cabinet Storage" }
  ],

  /* ✅ FEATURES (enhanced) */
  specTable: [
    {
      item: "Wooden Magic Corner Chrome",
      code: "7108",
      size: "900mm",
      finish: "Wooden Grey"
    },],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Wooden Magic Corner Chrome?",
      answer:
        "It is a corner cabinet storage system designed to utilize unused corner spaces in modular kitchens efficiently."
    },
    {
      question: "What materials are used in this unit?",
      answer:
        "It is made with a strong chrome metal frame and premium wooden shelves for durability and style."
    },
    {
      question: "What can be stored in it?",
      answer:
        "It is ideal for storing cookware, utensils, containers, and kitchen essentials."
    },
    {
      question: "Does it move smoothly?",
      answer:
        "Yes, it features a smooth pull-out sliding mechanism for easy access."
    },
    {
      question: "Why is it useful?",
      answer:
        "It maximizes corner space usage and improves kitchen organization and accessibility."
    }
  ]
}
];
